import i18next from 'i18next';
import { Condition } from '../@types/Condition';

export const translateCondition = (type: Condition): string => {
  switch (type) {
    case Condition.VeryGood:
      return i18next.t('mileageAndCondition.condition.veryGood.label');

    case Condition.Good:
      return i18next.t('mileageAndCondition.condition.good.label');

    case Condition.Ok:
      return i18next.t('mileageAndCondition.condition.ok.label');

    default:
      return '';
  }
};
